import React, { useState } from 'react';
import ConfirmationModal from './ConfirmationModal';

const AppsTable = ({ apps, handleDeleteApp, newApp, toggleAppEdit, setApps, handleNewAppChange, submitNewApp, updateAppField, handleSaveApp }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [appToDelete, setAppToDelete] = useState(null);

  const handleDeleteClick = (appId) => {
    setAppToDelete(appId);
    setIsModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (appToDelete) {
      await handleDeleteApp(appToDelete);
    }
    setIsModalOpen(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setAppToDelete(null);
  };

  return (
    <>
      {/* 'Add New App' row */}
      <tr key="new-app">
        <td className="py-2 px-2 border-b italic">Add New App</td>
        <td className="py-2 px-2 border-b">
          <input
            type="text"
            placeholder="App Name"
            onChange={(e) => handleNewAppChange('name', e.target.value)}
          />
        </td>
        <td className="py-2 px-2 border-b">
          <input
            type="text"
            placeholder="Description"
            onChange={(e) => handleNewAppChange('description', e.target.value)}
          />
        </td>
        <td className="py-2 px-2 border-b">
          <input
            type="text"
            placeholder="Route (e.g., /app-name)"
            onChange={(e) => handleNewAppChange('route', e.target.value)}
          />
        </td>
        <td className="py-2 px-2 border-b">
          <button
            className="bg-blue-950 hover-bg-blue-700 text-white font-bold py-2 px-2 w-full"
            onClick={() => submitNewApp(newApp, setApps)}
          >
            Add App
          </button>
        </td>
      </tr>
      {apps.map((app) => (
        <tr key={app.id}>
          <td className="py-2 px-2 border-b">{app.id}</td>
          {app.isEditing ? (
            <>
              <td className="py-2 px-2 border-b">
                <input
                  type="text"
                  value={app.name}
                  onChange={(e) => updateAppField(app.id, 'name', e.target.value)}
                />
              </td>
              <td className="py-2 px-2 border-b">
                <input
                  type="text"
                  value={app.description || ''}
                  onChange={(e) => updateAppField(app.id, 'description', e.target.value)}
                />
              </td>
              <td className="py-2 px-2 border-b">
                <input
                  type="text"
                  value={app.route}
                  onChange={(e) => updateAppField(app.id, 'route', e.target.value)}
                />
              </td>
            </>
          ) : (
            <>
              <td className="py-2 px-2 border-b">{app.name}</td>
              <td className="py-2 px-2 border-b">{app.description}</td>
              <td className="py-2 px-2 border-b">{app.route}</td>
            </>
          )}
          <td className="py-2 px-2 border-b">
            {app.isEditing ? (
              <>
                <button
                  className="bg-blue-500 hover-bg-blue-700 text-white font-bold py-2 px-2 mr-2 w-full"
                  onClick={() => handleSaveApp(app.id)}
                >
                  Save
                </button>
                <button
                  className="bg-sky-800 hover-bg-sky-700 text-white font-bold py-2 px-2 w-full"
                  onClick={() => toggleAppEdit(app.id)}
                >
                  Close Edit
                </button>
              </>
            ) : (
              <>
                <button
                  className="bg-blue-950 hover-bg-blue-700 text-white font-bold py-2 px-2 mr-2 w-full mb-1"
                  onClick={() => handleDeleteClick(app.id)}
                >
                  Delete
                </button>
                <button
                  className="bg-sky-800 hover-bg-sky-700 text-white font-bold py-2 px-2 w-full"
                  onClick={() => toggleAppEdit(app.id)}
                >
                  Edit
                </button>
              </>
            )}
          </td>
        </tr>
      ))}

      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
        message="Are you sure you want to delete this app? It cannot be recovered"
      />
    </>
  );
};

export default AppsTable;
